import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Banknote } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { RecordPayment } from "@/features/finance/components/record-payment";

function FinancePaymentsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <PageHeader title={t(msg`Payments`)} backTo="/finance" icon={Banknote} />
      <div class="mt-4">
        <RecordPayment />
      </div>
    </PageContainer>
  );
}

export const financePaymentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/payments",
  component: withFeatureGate("billing.core", FinancePaymentsPage),
});
